export interface TeamMember {
  id: string
  name: string
  title?: string
  bio?: string
  email?: string
  linkedin_url?: string
  position: number
  photo_url?: string
  initials: string
}

export interface LinkedinLookupResult {
  name: string
  title: string | null
  photo_url: string | null
  bio: string | null
  country_code: string | null
}

export interface LinkedinLookupError {
  error: string
}

export interface Candidate {
  id: string
  subject_id: string
  subject_type: string

  accreditation_level_min: string
  deal_investment_min: number
  deal_investment_range: string
  fund_investment_min: number
  fund_investment_range: string
  spv_investment_min: number
  spv_investment_range: string
  industries_excluded: string[]
  industries_interested: string[]
  investment_stage: string
  investment_thesis: string
  investment_types_interested: string[]
  university_affiliations: string[]
  team_members: TeamMember[]
}

export interface GroupCandidateExpanded extends Candidate {
  subject: {
    id: string
    name: string
    subdomain: string
    logo_url: string | null
  }
}
export interface InvestorCandidateExpanded extends Candidate {
  subject: {
    id: string
    name: string
    email: string
    accredited_status: string
    screening_check_id: string
    screening_check_status: string
    country: string
    linkedin_url: string | null
    profile_picture: string | null
  }
}
export const INVESTMENT_TYPE_LABELS: Record<string, string> = {
  fund: 'Fund',
  syndicate: 'Syndicate',
  angel_group: 'Angel Group',
}

export interface Connection {
  id: string
  group_status: string
  investor_status: string

  candidate_group: GroupCandidateExpanded
  candidate_investor: InvestorCandidateExpanded
}
